<!-- 代理等级变更日志 -->
<template>
    <page>
        <c-dialog ref="memberDialog" :title="title" width="500" enable-flex @resolve="setMemberPointsHandle">
            <c-form ref="memberForm">
                <c-form-item type="input" label="会员昵称:" name="nick_name" disabled></c-form-item>
                <c-form-item type="input" label="会员手机号:" name="user_manage_mobilephone" disabled></c-form-item>
                <c-form-item type="input" label="会员等级:" name="user_level_name" disabled></c-form-item>
                <c-form-item type="input" label="当前积分:" name="points" disabled></c-form-item>
                <c-form-item type="radio" label="积分变更类型" name="deduction_type" v-model="deductionType" :options="Type" required
                             word="补积分：会员积分增加；扣积分：会员积分减少(最少只能减至0)"></c-form-item>
                <c-form-item type="number" label="积分变更数量" name="points" decimal="0" :limit="[1,999999]" required></c-form-item>
                <c-form-item type="number" v-if="deductionType==1" label="积分有效期" name="expired_period" decimal="0" v-model="overdueMonth"
                             :limit="[1,999]" required input-unit="月" word="获得积分后，这些积分在该期限内不使用则自动过期"></c-form-item>
                <c-form-item type="textarea" label="积分变更原因" name="remark" :maxlength="100"></c-form-item>
            </c-form>
        </c-dialog>
    </page>
</template>

<script>

    export default {
        components: {

        },
		props: {
        },

        data() {
            return {
                platform_user_id:0,
                platform_user_points:0,
                title:'会员积分补扣',
                serachParams:{},
                overdueMonth:12,//，默认过期时间（月）
                deductionType:1,//1=补积分  2=扣积分
                Type: [{
                    name: '补积分',
                    value: 1
                },{
                    name: '扣积分',
                    value: 2
                }
                ],
            }
        },
		
		methods: {
			open(data) {
                this.platform_user_id = data.platform_user_id;
                this.platform_user_points = data.points||0;
                this.$refs.memberForm.clear();
                this.$refs.memberForm.set({
                    share_user_name: (data.share_user_nick_name || "") + "【" + (data.share_user_manage_mobilephone || '--') + "】",
                    tran_share_user_name: (data.share_user_nick_name || "") + "【" + (data.share_user_manage_mobilephone || '--') + "】",
                    user_level_name: data.user_level_name || '普通会员',
                    share_user_id: data.share_user_id,
                    user_level: data.user_level,
                    nick_name: data.nick_name,
                    user_manage_mobilephone: data.user_manage_mobilephone,
                    points: data.points,
                    deduction_type: 1
                });
                this.$refs.memberDialog.open();
			},

            //保存调整代理等级
            setMemberPointsHandle(stop) {
                stop();
                this.$refs.memberForm.submit({
                    url: '/platform_user/points/edit',
                    rule: {
                        deduction_type: '请选择积分变更类型',
                        points: [{
                            type: 'empty',
                            word: '请输入积分变更数量'
                        },{
                            type: 'function',
                            fun: value => {
                                return value > 0;
                            },
                            word: '积分变更数量只能输入大于0的正整数'
                        },{
                            type: 'function',
                            fun:(value,data) =>{
                                return data.deduction_type == 1 || this.platform_user_points >= value;
                            },
                            word: '扣除积分数量不能大于会员现有积分'
                        }],
                        expired_period:[{
                            type:'empty',
                            skip: () => {
                                return this.deductionType == 2;
                            },
                            word: '请填写积分过期时间'
                        }]
                    },
                    dataFormatter: data => {
                        data.platform_user_id = this.platform_user_id;
                        return data;
                    },

                    success: data => {
                        this.$refs.memberDialog.close();
                        this.$message({
                            text: '请求发送成功，调整结果可能稍有延迟!'
                        });
                        //调用响应方法
                        this.$emit('resolve',this.platform_user_id);
                    }
                })
            }
        }
	}
</script>